/**
 * Formats a big number
 * @param {number} num
 * @param {string=} divider THe divider for numbers like 50,000 (divider=',')
 * @returns {string}
 */
export function formatBigNumber(num, divider = ",") {
  if (num === null || num === undefined) {
    return null;
  }

  const sign = num < 0 ? "-" : "";
  num = Math.abs(num);

  if (num > 1e54) {
    return sign + "inf";
  }

  if (num < 10 && !Number.isInteger(num)) {
    return sign + num.toFixed(2);
  }
  if (num < 50 && !Number.isInteger(num)) {
    return sign + num.toFixed(1);
  }
  num = Math.floor(num);

  if (num < 1000) {
    return sign + "" + num;
  }

  let rest = num;
  let out = "";

  while (rest >= 1000) {
    out =
      (rest % 1000).toString().padStart(3, "0") +
      (out !== "" ? divider : "") +
      out;
    rest = Math.floor(rest / 1000);
  }

  out = rest + divider + out;
  return sign + out;
}

export function formatSecondsShort(secs) {
  if (secs === null || secs === undefined) {
    return null;
  }

  secs = Math.ceil(secs);
  if (secs < 60) {
    return secs + "s";
  } else if (secs < 60 * 60) {
    const minutes = Math.floor(secs / 60);
    const seconds = secs % 60;
    return minutes + "m " + seconds + "s";
  } else {
    const hours = Math.floor(secs / 3600);
    const minutes = Math.floor(secs / 60) % 60;
    return hours + "h " + minutes + "m";
  }
}

export function formatPercentage(pct) {
  return Math.round(pct * 100.0 * 100.0) / 100.0 + "%";
}

/**
 * Converts a string like "1.1.17" to "001001017"
 * @param {string} version
 */
export function versionToInt(version) {
  const parts = version.split(".");
  if (parts.length !== 3) {
    return 0;
  }

  return +parts[0] * 1000 * 1000 + +parts[1] * 1000 + +parts[2];
}
